import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import TableData from '../../../shared/ui/TableData'

import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
  },
})

const CoursePriceListView = ({ theme, classes, course }) => {    
  
  const rows = course.prices

  const columns = [
    { key: 'min_participant_count', label: 'Pax'},
    { key: 'price_per_participant', label: 'Price Per Pax', type: 'currency' },
  ]  
  
  const getCellValue = (row, column, rowIndex, columnIndex) => {
    if (column.key == 'min_participant_count') {
      const minCount = parseInt(row[column.key])
      if (rowIndex < (rows.length -1)) {
        const maxCount = parseInt(rows[rowIndex+1][column.key])
        if (maxCount > minCount)
          return `${minCount} - ${maxCount-1} pax`
      }
      return `${minCount} pax or more`
    }      
    
    return row[column.key]
  } 
    
  return (
    <TableData columns={columns} 
      hideHeaderRow={true}
      rows={rows}
      getCellValue={getCellValue}
      size="small"
    />
  )  
}
  
const mapStateToProps = (state, ownProps) => {
  return {
    
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(CoursePriceListView)
)
